module.exports = __webpack_public_path__ + "img/aboutme.6fc1a641.jpg";